export default __webpack_public_path__ + "static/media/light-on.ab348e59.svg";